// component/dashboard/Dashboard.js
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { 
  FaUsers, 
  FaChalkboardTeacher, 
  FaBookOpen, 
  FaChartLine, 
  FaUserGraduate, 
  FaClipboardList, 
  FaBell 
} from 'react-icons/fa';

const Dashboard = () => {
  const adminStats = [
    { 
      icon: <FaUsers />, 
      value: '1,248', 
      label: 'Total Students', 
      color: 'primary' 
    },
    { 
      icon: <FaChalkboardTeacher />, 
      value: '38', 
      label: 'Active Instructors', 
      color: 'success' 
    },
    { 
      icon: <FaBookOpen />, 
      value: '124', 
      label: 'Total Courses', 
      color: 'info' 
    },
    { 
      icon: <FaChartLine />, 
      value: '87%', 
      label: 'Avg. Completion Rate', 
      color: 'warning' 
    },
  ];

  const quickAdminActions = [
    { icon: <FaBookOpen />,        label: 'Manage Courses',       link: '/admin/courses' },
    { icon: <FaUsers />,           label: 'Manage Students',      link: '/admin/students' },
    { icon: <FaChalkboardTeacher />, label: 'Manage Instructors', link: '/admin/instructors' },
    { icon: <FaUserGraduate />,    label: 'View Batches',         link: '/admin/batches' },
    { icon: <FaClipboardList />,   label: 'Reports & Analytics',  link: '/admin/reports' },
    { icon: <FaBell />,            label: 'Pending Approvals',    link: '/admin/approvals' },
  ];

  return (
    <Container fluid className="py-4">
      {/* Header */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 fw-bold text-dark mb-1">Admin Dashboard</h1>
              <p className="text-muted mb-0">Overview of your learning platform • {new Date().toLocaleDateString('en-IN')}</p>
            </div>
            {/* <Button variant="primary" className="d-flex align-items-center">
              <FaBookOpen className="me-2" />
              Add New Course
            </Button> */}
          </div>
        </Col>
      </Row>

      {/* Key Statistics */}
      <Row className="mb-5">
        {adminStats.map((stat, index) => (
          <Col key={index} lg={3} md={6} className="mb-4">
            <Card className="modern-card border-0 shadow-sm h-100">
              <Card.Body className="p-4">
                <div className={`d-flex align-items-center mb-3 text-${stat.color}`}>
                  <div className="fs-2 me-3">{stat.icon}</div>
                  <div>
                    <h3 className="fw-bold mb-0">{stat.value}</h3>
                    <p className="text-muted mb-0 small">{stat.label}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Quick Actions Grid */}
      <Row className="mb-5">
        <Col lg={8}>
          <Card className="modern-card border-0 shadow-sm">
            <Card.Header className="bg-white border-0 d-flex justify-content-between align-items-center">
              <h5 className="fw-bold mb-0">Quick Admin Actions</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                {quickAdminActions.map((action, index) => (
                  <Col key={index} md={4} sm={6} className="mb-4">
                    <Button
                      variant="outline-primary"
                      className="w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-center"
                      style={{ 
                        minHeight: '140px', 
                        border: '2px dashed #0d6efd',
                        borderRadius: '12px'
                      }}
                      href={action.link}
                    >
                      <div className="fs-2 text-primary mb-3">{action.icon}</div>
                      <span className="fw-semibold fs-5">{action.label}</span>
                    </Button>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* Right Column - Recent/Pending Activity */}
        <Col lg={4}>
          <Card className="modern-card border-0 shadow-sm h-100">
            <Card.Header className="bg-white border-0">
              <h5 className="fw-bold mb-0">Pending Tasks</h5>
            </Card.Header>
            <Card.Body className="d-flex flex-column justify-content-center">
              <div className="text-center py-5">
                <FaBell className="text-warning mb-4" size={60} />
                <h5 className="text-muted mb-3">No pending approvals</h5>
                <p className="text-muted small mb-4">
                  Student registrations, certificate requests,<br/>
                  and instructor applications will appear here
                </p>
                {/* <Button variant="outline-warning" size="sm">
                  Check All Requests
                </Button> */}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;